import React, { Component } from 'react';
import { Portal } from 'react-portal';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import copyToClipboard from 'copy-to-clipboard';

import ButtonDeprecated, {
  BUTTON_THEME_BLUE,
} from 'client/components/ButtonDeprecated';
import branch from 'client/core/branch';

const initialState = {
  showMessage: false,
};

@branch({})
class SrInviteRoommateModal extends Component {
  static propTypes = {
    roommateInviteLink: PropTypes.string,
    showModal: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = initialState;
  }

  _onCopyLinkClicked = () => {
    const {
      roommateInviteLink,
    } = this.props;
    copyToClipboard(roommateInviteLink);
    this.setState({ showMessage: true });
    setTimeout(() => {
      this.setState({ showMessage: false });
    }, 2000);
  };

  render() {
    const {
      roommateInviteLink,
      showModal,
      onClose,
    } = this.props;
    const {
      showMessage,
    } = this.state;

    if (!showModal || !roommateInviteLink) {
      return null;
    }

    return (
      <Portal>
        <div className='SrInviteRoommateModal'>
          <div className='backdrop' onClick={onClose}>
            <div className='form' onClick={(evt) => evt.stopPropagation()}>
              <span className='title'>invite a roommate</span>
              <span className='subtitle'>send this link to your roommates</span>
              <div className={classnames('formMessage success', {
                showMessage: showMessage,
              })}
              >
                <span>Copied link, send it to your roommates!</span>
              </div>
              <input
                onClick={() => this._onCopyLinkClicked()}
                className='linkInput'
                value={roommateInviteLink}
                readOnly
              />
              <ButtonDeprecated
                className='copyLinkButton'
                theme={BUTTON_THEME_BLUE}
                onClick={() => this._onCopyLinkClicked()}
              >
                copy link
              </ButtonDeprecated>
            </div>
          </div>
        </div>
      </Portal>
    );
  }
}

SrInviteRoommateModal.displayName = 'SrInviteRoommateModal';

export default SrInviteRoommateModal;
